import {
  SET_TEMPLATES_LOADING,
  SET_TEMPLATES_ERROR,
  SET_SHIPMENT_TEMPLATES,
  SET_BULK_TEMPLATES
} from "./mutation-types";
import Request from "@/services/request";
import {
  SHIPMENT_TEMPLATES_URL,
  UPDATE_PRODUCT_SHIPMENT,
  BULK_DELETE_TEMPLATE,
  BULK_SHIPMENT_TEMPLATE_UPDATE,
  BULK_PRODUCT_TEMPLATE_UPDATE,
  BULK_STOCK_PRICE_TEMPLATE_UPDATE,
  BULK_PRODUCT_SAFETY_TEMPLATE,
  BULK_PRODUCT_NUTRITIONAL_TEMPLATE,
  BULK_PRODUCT_SAFETY_INFO_UPDATE,
  BULK_STOCK_CODE_TEMPLATE_UPDATE,
  DEAL_TEMPLATE_CREATE,
  DEAL_TEMPLATE_DOWNLOAD,
  DEAL_CREATED_TEMPLATE_DOWNLOAD,
} from "@/utils/enum/endpoints";

const request = new Request();

const getShipmentTemplates = async ({ commit }) => {
  try {
    commit(SET_TEMPLATES_LOADING, true);
    const res = await request.get(SHIPMENT_TEMPLATES_URL);
    commit(SET_SHIPMENT_TEMPLATES, res.data);
    return res;
  } catch (error) {
    commit(SET_TEMPLATES_ERROR, error);
    return Promise.reject(error);
  } finally {
    commit(SET_TEMPLATES_LOADING, false);
  }
};

const updateShipmentTemplate = async (_, { pids, shipmentId }) => {
  try {
    await request.put(UPDATE_PRODUCT_SHIPMENT, {
      productIds: pids,
      shipmentId: shipmentId,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

const getDeleteBulkTemplate = async () => {
  try {
    const res = await request.get(BULK_DELETE_TEMPLATE);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getBulkUpdateTemplates = async ({ commit }, { type, params }) => {
  const types = [
    "SHIPMENT_TEMPLATE",
    "PRODUCT",
    "STOCK_PRICE",
    "PRODUCT-SAFETY-UPDATE",
    "PRODUCT-NUTRITIONAL-UPDATE",
    "PRODUCT-SAFETY-INFO-UPDATE",
    "STOCK_CODE",
  ];
  const qs = params || { productStatusList: "Active" };

  if (!types.includes(type)) {
    const error = `Type should be one of ${types.join(", ")}. Given : ${type}`;
    commit(SET_TEMPLATES_ERROR, error);
    return Promise.reject(error);
  }

  try {
    commit(SET_TEMPLATES_LOADING, true);
    let endpoint = null;
    switch (type) {
      case types[0]:
        endpoint = BULK_SHIPMENT_TEMPLATE_UPDATE;
        break;
      case types[1]:
        endpoint = BULK_PRODUCT_TEMPLATE_UPDATE;
        break;
      case types[2]:
        endpoint = BULK_STOCK_PRICE_TEMPLATE_UPDATE;
        break;
      case types[3]:
        endpoint = BULK_PRODUCT_SAFETY_TEMPLATE;
        break;
      case types[4]:
        endpoint = BULK_PRODUCT_NUTRITIONAL_TEMPLATE;
        break;
      case types[5]:
        endpoint = BULK_PRODUCT_SAFETY_INFO_UPDATE;
        break;
      case types[6]:
        endpoint = BULK_STOCK_CODE_TEMPLATE_UPDATE;
        break;
    }

    const res = await request.get(endpoint, qs);
    commit(SET_BULK_TEMPLATES, { [type]: res.data });
    return res;
  } catch (error) {
    commit(SET_TEMPLATES_ERROR, error);
    return Promise.reject(error);
  } finally {
    commit(SET_TEMPLATES_LOADING, false);
  }
};

const dealCreateTemplate = async ({ rootState, dispatch }, templateData) => {
  const { sellerId } = rootState.auth.user;
  const { startDate, finishDate } = templateData;
  const endpoint = `${DEAL_TEMPLATE_CREATE}/${sellerId}`;
  const params = new URLSearchParams({
    startDate,
    finishDate,
  }).toString();

  try {
    const res = await request.post(
      `${endpoint}?${params}`,
      {},
      {
        baseURL: "/sellerofficeapi/rest",
        headers: {
          Accept: "application/json",
        },
      }
    );

    const templateId = res.data.id;
    const fileName = res.data.dealFile;

    const downloadUrl = `${DEAL_CREATED_TEMPLATE_DOWNLOAD}/${sellerId}/${templateId}`;

    dispatch("common/downloadFile", { downloadUrl, fileName }, { root: true });

    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const dealTemplateDownloadLink = async (
  { rootState, dispatch },
  { fileName, batchId }
) => {
  const { sellerId } = rootState.auth.user;
  try {
    const downloadUrl = `${DEAL_CREATED_TEMPLATE_DOWNLOAD}/${sellerId}/${batchId}`;

    dispatch("common/downloadFile", { downloadUrl, fileName }, { root: true });
  } catch (error) {
    return Promise.reject(error);
  }
};

const dealTemplateDownloadFromUpload = async (
  { rootState, dispatch },
  { fileName, batchId }
) => {
  const { sellerId } = rootState.auth.user;
  try {
    const downloadUrl = `${DEAL_TEMPLATE_DOWNLOAD}/${sellerId}/${batchId}`;

    dispatch("common/downloadFile", { downloadUrl, fileName }, { root: true });
  } catch (error) {
    return Promise.reject(error);
  }
};

const dealRejectedReasonRaportDownload = async (
  { rootState, dispatch },
  { fileName, batchId }
) => {
  const { sellerId } = rootState.auth.user;
  try {
    const downloadUrl = `${DEAL_TEMPLATE_DOWNLOAD}/${sellerId}/${batchId}/?failedFile=true`;

    dispatch("common/downloadFile", { downloadUrl, fileName }, { root: true });
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getShipmentTemplates,
  updateShipmentTemplate,
  getDeleteBulkTemplate,
  getBulkUpdateTemplates,
  dealCreateTemplate,
  dealTemplateDownloadLink,
  dealTemplateDownloadFromUpload,
  dealRejectedReasonRaportDownload,
};
